import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { NoLangGuard } from './core/guards/no-lang.guard';
import { AppComponent } from './app.component';
import { ILanguage } from '@cinetixx/cinetixx-ui';
import { languagesSnippetsGuard } from './language/core/guards/languages-snippets.guard';

const userLang = JSON.parse(localStorage.getItem('user-lang')) as ILanguage;
const browserLang = navigator.language.split('-')[0];
const routes: Routes = [
  {
    path: '',
    redirectTo: `${ userLang?.token ?? browserLang ?? environment.fallbackLanguage }/dashboard`,
    pathMatch: 'full',
  },
  {
    path: ':language',
    loadChildren: () => import('./_main/main.module').then(m => m.MainModule),
    canActivate: [languagesSnippetsGuard]
  },
  {
    path: '**',
    canActivate: [NoLangGuard],
    component: AppComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    bindToComponentInputs: true
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
